document.addEventListener('DOMContentLoaded', function(){

    const openBtn = document.getElementById('openCouponDrawer');
    const drawer = document.querySelector('.coupon-drawer');
    const overlay = document.querySelector('.coupon-drawer-overlay');
    const closeBtn = document.querySelector('.close-coupon-drawer');

    function openDrawer(){

        drawer.classList.add('active');
        overlay.classList.add('active');

        document.body.style.overflow = 'hidden';

    }

    function closeDrawer(){

        drawer.classList.remove('active');
        overlay.classList.remove('active');

        document.body.style.overflow = '';

    }

    openBtn?.addEventListener('click', openDrawer);

    closeBtn?.addEventListener('click', closeDrawer);

    overlay?.addEventListener('click', closeDrawer);

    function showCouponError(message){

        let errorEl = drawer?.querySelector('.coupon-drawer-error');

        if(!errorEl){
            const inputWrap = drawer?.querySelector('.coupon-drawer-input');
            if(!inputWrap) return;
            errorEl = document.createElement('p');
            errorEl.className = 'coupon-drawer-error';
            errorEl.setAttribute('role', 'alert');
            errorEl.style.cssText = 'color:#b42318;font-size:13px;margin:8px 0 0;';
            inputWrap.insertAdjacentElement('afterend', errorEl);
        }

        errorEl.textContent = message;
        errorEl.hidden = false;

    }

    function clearCouponError(){

        const errorEl = drawer?.querySelector('.coupon-drawer-error');
        if(errorEl){
            errorEl.textContent = '';
            errorEl.hidden = true;
        }

    }

    async function applyCoupon(code){

        code = (code || '').trim();

        if(!code) return;

        clearCouponError();

        const encoded = encodeURIComponent(code);

        try {

            await fetch(`/discount/${encoded}?redirect=/cart`, { credentials: 'same-origin' });

            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            const cart = await res.json();

            const match = (cart.discount_codes || []).find(d => (d.code || '').toLowerCase() === code.toLowerCase());

            if(match && match.applicable === true){

                try { localStorage.setItem('applied_coupon', code); } catch(e) {}

                document.querySelector('.coupon-applied-box')?.classList.remove('hidden');

                const codeEl = document.querySelector('.coupon-applied-code');
                if(codeEl) codeEl.textContent = code;

                closeDrawer();

            } else {

                showCouponError("This code can't be applied to your bag.");

            }

        } catch(e) {

            showCouponError('Something went wrong. Please try again.');

        }

    }

    document.querySelectorAll('.coupon-apply-btn').forEach(button => {

        button.addEventListener('click', function(){

            const code = this.dataset.code;

            applyCoupon(code);

        });

    });

    document.getElementById('manualCouponApply')?.addEventListener('click', function(){

        const code = document.getElementById('manualCouponInput').value;

        if(code != ''){

            applyCoupon(code);

        }

    });

});